export default __webpack_public_path__ + "static/img-nhs-app--mobile-acee788bdd830a216f56f0edcb102ab1.jpg";